export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEBSGEFISIBvU8NAb1RCQK9UwIEvVYEEb1bQRUhYb1thT8AAQABAAEAAQAZAB8AAQABAAYAgTIAAQABAAEAAQAZAB8AAQABAAYAYQEldQG+Ag==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/V.bcmap
// module id = 733
// module chunks = 502